module.exports = {
	"features": [
		{
			"type": "Feature",
			"properties": {
				"key": "danderyd",
				"name": "Danderyd"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.022864,
							59.398759
						],
						[
							18.022693,
							59.396882
						],
						[
							18.028287,
							59.395887
						],
						[
							18.039254,
							59.397081
						],
						[
							18.038448,
							59.399841
						],
						[
							18.02792,
							59.400761
						],
						[
							18.022864,
							59.398759
						]
					]
				],
				"type": "Polygon"
			},
			"id": "187943ad8d88cdcd5ecbf734f17fd2de"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "sodero",
				"name": "Söder - öst"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077083,
							59.313341
						],
						[
							18.077904,
							59.311665
						],
						[
							18.091932,
							59.309545
						],
						[
							18.093394,
							59.312163
						],
						[
							18.08706,
							59.313236
						],
						[
							18.077083,
							59.313341
						]
					]
				],
				"type": "Polygon"
			},
			"id": "1b865a55d9ecddaa99b529c7bf1712d9"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "vasastan",
				"name": "Norrmalm - Vasastan"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.03981,
							59.341146
						],
						[
							18.042929,
							59.33802
						],
						[
							18.056588,
							59.338322
						],
						[
							18.062073,
							59.339857
						],
						[
							18.061697,
							59.346603
						],
						[
							18.056642,
							59.350852
						],
						[
							18.04992,
							59.349838
						],
						[
							18.03981,
							59.341146
						]
					]
				],
				"type": "Polygon"
			},
			"id": "1de8de51ae7ab9f0fc72bc073821fabc"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "ostermalm",
				"name": "Östermalm"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077836,
							59.340061
						],
						[
							18.070399,
							59.341626
						],
						[
							18.062762,
							59.336609
						],
						[
							18.064663,
							59.334057
						],
						[
							18.075202,
							59.334517
						],
						[
							18.077836,
							59.340061
						]
					]
				],
				"type": "Polygon"
			},
			"id": "25584c05433adebc133014a7961d6446"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "soder",
				"name": "Söder - söder"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.080625,
							59.309121
						],
						[
							18.071193,
							59.308037
						],
						[
							18.070725,
							59.302873
						],
						[
							18.076989,
							59.302193
						],
						[
							18.082893,
							59.302597
						],
						[
							18.080625,
							59.309121
						]
					]
				],
				"type": "Polygon"
			},
			"id": "37124c21bdaa7abf7a3365c468222f19"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "sodernv",
				"name": "Söder - nordväst"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.049172,
							59.32121
						],
						[
							18.049778,
							59.318901
						],
						[
							18.056978,
							59.318801
						],
						[
							18.067564,
							59.320283
						],
						[
							18.066245,
							59.321401
						],
						[
							18.049172,
							59.32121
						]
					]
				],
				"type": "Polygon"
			},
			"id": "420599e24c58d39e2aaf904a0fe7c00e"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "djurgarden",
				"name": "Skeppshomen - Djurgården"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077241,
							59.326598
						],
						[
							18.089999,
							59.332233
						],
						[
							18.100908,
							59.33221
						],
						[
							18.103682,
							59.320561
						],
						[
							18.088474,
							59.321103
						],
						[
							18.077241,
							59.326598
						]
					]
				],
				"type": "Polygon"
			},
			"id": "7239fd411cd000383604d52972007db7"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "hornstull",
				"name": "Hornstull"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.036092,
							59.320034
						],
						[
							18.025048,
							59.319213
						],
						[
							18.024526,
							59.315485
						],
						[
							18.039006,
							59.309693
						],
						[
							18.05479,
							59.312356
						],
						[
							18.051007,
							59.315263
						],
						[
							18.037484,
							59.315596
						],
						[
							18.036092,
							59.320034
						]
					]
				],
				"type": "Polygon"
			},
			"id": "8474a0c47e873e198f2a41a9002afac9"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "vkungsholmen",
				"name": "Västra Kungsholmen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							17.996021,
							59.330818
						],
						[
							17.995507,
							59.336605
						],
						[
							18.006024,
							59.341327
						],
						[
							18.012992,
							59.341632
						],
						[
							18.022392,
							59.339472
						],
						[
							18.006656,
							59.328004
						],
						[
							17.996021,
							59.330818
						]
					]
				],
				"type": "Polygon"
			},
			"id": "91aff4c989fd8d2c95858cd682201953"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "frihamnen",
				"name": "Frihamnen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.114475,
							59.343693
						],
						[
							18.11331,
							59.342161
						],
						[
							18.116561,
							59.340093
						],
						[
							18.121336,
							59.339301
						],
						[
							18.12775,
							59.340723
						],
						[
							18.12194,
							59.344265
						],
						[
							18.114475,
							59.343693
						]
					]
				],
				"type": "Polygon"
			},
			"id": "c5608dda66451177d002afa2357b0634"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "city",
				"name": "City"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.08147,
							59.332276
						],
						[
							18.076407,
							59.333312
						],
						[
							18.069997,
							59.33259
						],
						[
							18.068081,
							59.330973
						],
						[
							18.0658,
							59.329344
						],
						[
							18.067648,
							59.327727
						],
						[
							18.077273,
							59.327122
						],
						[
							18.080969,
							59.328728
						],
						[
							18.08147,
							59.332276
						]
					]
				],
				"type": "Polygon"
			},
			"id": "ca1e1eddc0fe95b35a689e91fd731fcd"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "langholmen",
				"name": "Långholmen - södra Kungsholmen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.027748,
							59.329742
						],
						[
							18.022713,
							59.329921
						],
						[
							18.012408,
							59.320781
						],
						[
							18.016273,
							59.319048
						],
						[
							18.03052,
							59.319785
						],
						[
							18.03977,
							59.321279
						],
						[
							18.027748,
							59.329742
						]
					]
				],
				"type": "Polygon"
			},
			"id": "f09b4c88bfa1e45470e231b51d7d6a8e"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "soderno",
				"name": "Söder - nordost"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.07488,
							59.32005
						],
						[
							18.071343,
							59.318119
						],
						[
							18.076612,
							59.314711
						],
						[
							18.089623,
							59.316389
						],
						[
							18.086135,
							59.318169
						],
						[
							18.07488,
							59.32005
						]
					]
				],
				"type": "Polygon"
			},
			"id": "fb66ca7d49edeb2adbf977bd6a3aaa3c"
		}
	],
	"type": "FeatureCollection"
};


//////////////////
// WEBPACK FOOTER
// ./src/json/new_areas.json
// module id = 128
// module chunks = 0